/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Meta_Defaultdescriptionname2Inputs */

const id_profile_meta_defaultdescriptionname2 = /** @type {(inputs: Profile_Meta_Defaultdescriptionname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pemain ini`)
};

const ms_profile_meta_defaultdescriptionname2 = /** @type {(inputs: Profile_Meta_Defaultdescriptionname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pemain ini`)
};

const da_profile_meta_defaultdescriptionname2 = /** @type {(inputs: Profile_Meta_Defaultdescriptionname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`denne spillers`)
};

const de_profile_meta_defaultdescriptionname2 = /** @type {(inputs: Profile_Meta_Defaultdescriptionname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dieses Spielers`)
};

const en_us2_profile_meta_defaultdescriptionname2 = /** @type {(inputs: Profile_Meta_Defaultdescriptionname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`this player's`)
};

const es_es2_profile_meta_defaultdescriptionname2 = /** @type {(inputs: Profile_Meta_Defaultdescriptionname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`este jugador`)
};

const es_mx2_profile_meta_defaultdescriptionname2 = /** @type {(inputs: Profile_Meta_Defaultdescriptionname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`este jugador`)
};

const fil_profile_meta_defaultdescriptionname2 = /** @type {(inputs: Profile_Meta_Defaultdescriptionname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`manlalarong ito`)
};

const fr_profile_meta_defaultdescriptionname2 = /** @type {(inputs: Profile_Meta_Defaultdescriptionname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ce joueur`)
};

const it_profile_meta_defaultdescriptionname2 = /** @type {(inputs: Profile_Meta_Defaultdescriptionname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`questo giocatore`)
};

const hu_profile_meta_defaultdescriptionname2 = /** @type {(inputs: Profile_Meta_Defaultdescriptionname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ezen játékos`)
};

const nl_profile_meta_defaultdescriptionname2 = /** @type {(inputs: Profile_Meta_Defaultdescriptionname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`deze speler`)
};

const no_profile_meta_defaultdescriptionname2 = /** @type {(inputs: Profile_Meta_Defaultdescriptionname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`denne spilleren`)
};

const pl_profile_meta_defaultdescriptionname2 = /** @type {(inputs: Profile_Meta_Defaultdescriptionname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tego gracza`)
};

const pt_br2_profile_meta_defaultdescriptionname2 = /** @type {(inputs: Profile_Meta_Defaultdescriptionname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`esse jogador`)
};

const pt_profile_meta_defaultdescriptionname2 = /** @type {(inputs: Profile_Meta_Defaultdescriptionname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`deste jogador`)
};

const ro_profile_meta_defaultdescriptionname2 = /** @type {(inputs: Profile_Meta_Defaultdescriptionname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`acestui jucător`)
};

const fi_profile_meta_defaultdescriptionname2 = /** @type {(inputs: Profile_Meta_Defaultdescriptionname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tämän pelaajan`)
};

const sv_profile_meta_defaultdescriptionname2 = /** @type {(inputs: Profile_Meta_Defaultdescriptionname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`denna spelares`)
};

const vi_profile_meta_defaultdescriptionname2 = /** @type {(inputs: Profile_Meta_Defaultdescriptionname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`người chơi này`)
};

const tr_profile_meta_defaultdescriptionname2 = /** @type {(inputs: Profile_Meta_Defaultdescriptionname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bu oyuncunun`)
};

const cs_profile_meta_defaultdescriptionname2 = /** @type {(inputs: Profile_Meta_Defaultdescriptionname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tohoto hráče`)
};

const bg_profile_meta_defaultdescriptionname2 = /** @type {(inputs: Profile_Meta_Defaultdescriptionname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`този играч`)
};

const ru_profile_meta_defaultdescriptionname2 = /** @type {(inputs: Profile_Meta_Defaultdescriptionname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`этого игрока`)
};

const uk_profile_meta_defaultdescriptionname2 = /** @type {(inputs: Profile_Meta_Defaultdescriptionname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`цього гравця`)
};

const ar_profile_meta_defaultdescriptionname2 = /** @type {(inputs: Profile_Meta_Defaultdescriptionname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هذا اللاعب`)
};

const hi_profile_meta_defaultdescriptionname2 = /** @type {(inputs: Profile_Meta_Defaultdescriptionname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस खिलाड़ी का`)
};

const th_profile_meta_defaultdescriptionname2 = /** @type {(inputs: Profile_Meta_Defaultdescriptionname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ของผู้เล่นนี้`)
};

const ja_profile_meta_defaultdescriptionname2 = /** @type {(inputs: Profile_Meta_Defaultdescriptionname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このプレイヤーの`)
};

const zh_cn2_profile_meta_defaultdescriptionname2 = /** @type {(inputs: Profile_Meta_Defaultdescriptionname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这位玩家的`)
};

const zh_hant1_profile_meta_defaultdescriptionname2 = /** @type {(inputs: Profile_Meta_Defaultdescriptionname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這位玩家的`)
};

const ko_profile_meta_defaultdescriptionname2 = /** @type {(inputs: Profile_Meta_Defaultdescriptionname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 플레이어`)
};

/**
* | output |
* | --- |
* | "this player's" |
*
* @param {Profile_Meta_Defaultdescriptionname2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_meta_defaultdescriptionname2 = /** @type {((inputs?: Profile_Meta_Defaultdescriptionname2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Meta_Defaultdescriptionname2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_meta_defaultdescriptionname2(inputs)
	if (locale === "ms") return ms_profile_meta_defaultdescriptionname2(inputs)
	if (locale === "da") return da_profile_meta_defaultdescriptionname2(inputs)
	if (locale === "de") return de_profile_meta_defaultdescriptionname2(inputs)
	if (locale === "en-US") return en_us2_profile_meta_defaultdescriptionname2(inputs)
	if (locale === "es-ES") return es_es2_profile_meta_defaultdescriptionname2(inputs)
	if (locale === "es-MX") return es_mx2_profile_meta_defaultdescriptionname2(inputs)
	if (locale === "fil") return fil_profile_meta_defaultdescriptionname2(inputs)
	if (locale === "fr") return fr_profile_meta_defaultdescriptionname2(inputs)
	if (locale === "it") return it_profile_meta_defaultdescriptionname2(inputs)
	if (locale === "hu") return hu_profile_meta_defaultdescriptionname2(inputs)
	if (locale === "nl") return nl_profile_meta_defaultdescriptionname2(inputs)
	if (locale === "no") return no_profile_meta_defaultdescriptionname2(inputs)
	if (locale === "pl") return pl_profile_meta_defaultdescriptionname2(inputs)
	if (locale === "pt-BR") return pt_br2_profile_meta_defaultdescriptionname2(inputs)
	if (locale === "pt") return pt_profile_meta_defaultdescriptionname2(inputs)
	if (locale === "ro") return ro_profile_meta_defaultdescriptionname2(inputs)
	if (locale === "fi") return fi_profile_meta_defaultdescriptionname2(inputs)
	if (locale === "sv") return sv_profile_meta_defaultdescriptionname2(inputs)
	if (locale === "vi") return vi_profile_meta_defaultdescriptionname2(inputs)
	if (locale === "tr") return tr_profile_meta_defaultdescriptionname2(inputs)
	if (locale === "cs") return cs_profile_meta_defaultdescriptionname2(inputs)
	if (locale === "bg") return bg_profile_meta_defaultdescriptionname2(inputs)
	if (locale === "ru") return ru_profile_meta_defaultdescriptionname2(inputs)
	if (locale === "uk") return uk_profile_meta_defaultdescriptionname2(inputs)
	if (locale === "ar") return ar_profile_meta_defaultdescriptionname2(inputs)
	if (locale === "hi") return hi_profile_meta_defaultdescriptionname2(inputs)
	if (locale === "th") return th_profile_meta_defaultdescriptionname2(inputs)
	if (locale === "ja") return ja_profile_meta_defaultdescriptionname2(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_meta_defaultdescriptionname2(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_meta_defaultdescriptionname2(inputs)
	return ko_profile_meta_defaultdescriptionname2(inputs)
});
export { profile_meta_defaultdescriptionname2 as "profile.meta.defaultDescriptionName" }